export const getHeightWithMargins = (element: Element): number => {
  const style = window.getComputedStyle(element);
  const clientHeight = element.getBoundingClientRect().height;
  const height = clientHeight || parseFloat(style.height) || 0;
  const marginTop = parseFloat(style.marginTop) || 0;
  const marginBottom = parseFloat(style.marginBottom) || 0;

  return height + marginTop + marginBottom;
};
